
import React, { useEffect, useState } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import MiniHeader from '../../components/global/MiniHeader'
import Footer from '../../components/global/Footer'
import { errorMessage } from '../../constants/errorMessage'
import { useNavigate, useParams } from 'react-router-dom'
import NoData from '../../components/NoData'
import { endParking } from '../../redux/actions/transientAction'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import ConfirmationModal from '../../global/ConfirmationModal'
import UpperHeader from '../../components/global/UpperHeader'
import StartEndDate from '../../components/global/StartEndDate'
import QRCodeComp from '../../components/global/QRCode'
import AmountPaid from '../../components/global/AmountPaid'
import ClockTimer from '../../components/global/ClockTimer'
import ExtendEndButton from '../../components/global/ExtendEndButton'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'
import PromoCode from '../../components/global/PromoCode'
import { falseLoaderOfPage, getTicketDetails } from '../../redux/actions/ReceiptsAction'
import { getConfigDetails } from '../../services/config'
import Loader from '../../global/Loader'
import { checkEstimateTime, encryptedFacilityKey, isExtendButton, isPermissionExist, isPromoValidateButton, priceGreaterOrNot, sortPortalPermissionByKey } from '../../utils/helper'
import { Row } from 'react-bootstrap'
import URL from '../../constants/urls'
import NotFound from '../../components/global/NotFound'
import CONSTANTS from '../../redux/constants'
import { addEventLog } from '../../redux/actions/EventsLog'
import PassWalletButtons from '../../components/global/PassWalletButton'


function ExtendResponse(props) {
  const [faciltyData, setFaciltyData] = useState(EMPTY_OBJECT)
  const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
  const [isDisplayDetails, setIsDisplayDetails] = useState(false)
  const [error, setError] = useState(false)
  const [isEndingParking, setIsEndingParking] = useState(false)
  const [isPromoCodeAppiled, setIsPromoCodeApplied] = useState(false)
  // const [isCouponApplied, setIsCouponApplied] = useState(false)
  const [btnloader, setBtnLoader] = useState({
    extend: false,
    endparking: false
  })
  const { partner, ticket_id } = useParams()
  const navigate = useNavigate()

  const { dispatch, notify, loader, partnerDetails } = props
  const [promoCode, setPromoCode] = useState('')
  const isWalletPermission = isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Wallet Pass')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {

    const extendDetails = JSON?.parse(localStorage?.getItem('ExtendData'))

    if (extendDetails?.ticket_number || ticket_id) {
      const payload = {
        'ticket': ticket_id ? ticket_id : extendDetails?.ticket_number,
        'phone': '',
        'cardLast4': '',
        'cardExpiry': '',
        'license_plate': '',
        'partner_id': getConfigDetails()?.PARTNER_ID,
      }
      dispatch(getTicketDetails(payload)).then((res) => {
        if (res?.status === 201 || res?.status === 200) {
          if (res?.data && res?.data != null) {
            // notify('success', 'T successfully')
            // setFaciltyData(res?.data)
            setFaciltyData(res?.data)
            localStorage.setItem('ExtendData', JSON.stringify(res?.data))
            // setRemainingAmount((Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)).toFixed(2))
            setError(false)
            if (res?.data?.is_checkout == '1') {
              const pushBack = JSON.parse(localStorage.getItem('history'))
              // if (pushBack?.route && pushBack?.facility) {
              //   notify('error', 'Session Expired!')
              //   navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
              // }
              if(pushBack?.route && pushBack?.facility){
                notify('error', 'Session Expired!')
                navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
              }else{
                  navigate(`/${partner}`)
              }
            }
          } else {
            setError(true)
            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            let errObject = {
              payload: payload,
              error: res,
              errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-ExtendResponse.js-63`))
          }
        } else {
          setError(true)
          notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
          let errObject = {
            payload: payload,
            error: res,
            errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
          }
          dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-ExtendResponse.js-63`))
        }
      }).catch((err) => {
        let errObject = {
          payload: payload,
          error: err,
          errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
        }
        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-ExtendResponse.js-63`))
        setError(true)
        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
      })
    } else {
      setIsEndingParking(false)
      dispatch(falseLoaderOfPage())
    }

    // setTicketData(Details)

    // const daysHoursLength = convertHoursToDaysMinutes(Number(Details?.length))
    // setHoursToDays(daysHoursLength)
  }, [EMPTY_ARRAY])


  const handleConfimationModal = () => {
    setIsConfimationModalOpen(!isConfimationModalOpen)
  }

  const handleExtend = () => {
    navigate(`/${partner}/extend/${faciltyData?.ticket_number}`)
  }
  const handleEndParking = () => {
    setIsConfimationModalOpen(!isConfimationModalOpen)
    setIsEndingParking(true)

    dispatch(endParking(faciltyData?.ticket_number)).then((res) => {
      if (res?.status === 201 || res?.status === 200) {
        if (res?.data && res?.data != null) {
          notify('success', 'Thank you for parking with us. Please visit us again')
          setFaciltyData(res?.data)
          setTimeout(() => {
            // const pushBack = JSON.parse(localStorage.getItem('history'))
            // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            const partnerData = JSON.parse(localStorage.getItem('partnerData') ? localStorage.getItem('partnerData') : '{}')
            const extendFacilityData = JSON.parse(localStorage.getItem('ExtendData') ? localStorage.getItem('ExtendData') : '{}')

            const partnerSLug = (partnerData && partnerData?.company_name && partnerData?.company_name != '') ? partnerData?.company_name.split(' ')?.[0].toLowerCase() : partner
            const facilityEncrypt = encryptedFacilityKey(extendFacilityData?.facility?.id)

            // const pushBack = JSON.parse(localStorage.getItem('history'))
            // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            localStorage.removeItem('paymentRecipt')
            localStorage.removeItem('ExtendData')
            navigate(`/${partner}/touchless-parking-${partnerSLug}/${facilityEncrypt}`)
            setIsEndingParking(false)

          }, 3000)
        } else {
          notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
          if(res?.status === 406) {
            setIsEndingParking(false)
          } else {
            setTimeout(() => {
              // const pushBack = JSON.parse(localStorage.getItem('history'))
              // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
              const partnerData = JSON.parse(localStorage.getItem('partnerData') ? localStorage.getItem('partnerData') : '{}')
              const extendFacilityData = JSON.parse(localStorage.getItem('ExtendData') ? localStorage.getItem('ExtendData') : '{}')

              const partnerSLug = (partnerData && partnerData?.company_name && partnerData?.company_name != '') ? partnerData?.company_name.split(' ')?.[0].toLowerCase() : partner
              const facilityEncrypt = encryptedFacilityKey(extendFacilityData?.facility?.id)

              // const pushBack = JSON.parse(localStorage.getItem('history'))
              // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
              localStorage.removeItem('paymentRecipt')
              localStorage.removeItem('ExtendData')
              navigate(`/${partner}/touchless-parking-${partnerSLug}/${facilityEncrypt}`)
              setIsEndingParking(false)

            }, 3000)
          }
          let errObject = {
            payload: faciltyData?.ticket_number,
            error: res,
            errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
          }
          dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} endParking-ExtendResponse.js-115`))
        }
      } else {
        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        if(res?.status === 406) {
          setIsEndingParking(false)
        } else {
          setTimeout(() => {
            // const pushBack = JSON.parse(localStorage.getItem('history'))
            // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            const partnerData = JSON.parse(localStorage.getItem('partnerData') ? localStorage.getItem('partnerData') : '{}')
            const extendFacilityData = JSON.parse(localStorage.getItem('ExtendData') ? localStorage.getItem('ExtendData') : '{}')

            const partnerSLug = (partnerData && partnerData?.company_name && partnerData?.company_name != '') ? partnerData?.company_name.split(' ')?.[0].toLowerCase() : partner
            const facilityEncrypt = encryptedFacilityKey(extendFacilityData?.facility?.id)

            // const pushBack = JSON.parse(localStorage.getItem('history'))
            // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            localStorage.removeItem('paymentRecipt')
            localStorage.removeItem('ExtendData')
            navigate(`/${partner}/touchless-parking-${partnerSLug}/${facilityEncrypt}`)
            setIsEndingParking(false)

          }, 3000)
        }
        let errObject = {
          payload: faciltyData?.ticket_number,
          error: res,
          errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
        }
        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} endParking-ExtendResponse.js-115`))
      }
    }).catch((err) => {
      let errObject = {
        payload: faciltyData?.ticket_number,
        error: err,
        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
      }
      dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} endParking-ExtendResponse.js-115`))
      if(err?.status === 406) {
          setIsEndingParking(false)
        } else {
        setTimeout(() => {
          // const pushBack = JSON.parse(localStorage.getItem('history'))
          // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
          const partnerData = JSON.parse(localStorage.getItem('partnerData') ? localStorage.getItem('partnerData') : '{}')
          const extendFacilityData = JSON.parse(localStorage.getItem('ExtendData') ? localStorage.getItem('ExtendData') : '{}')

          const partnerSLug = (partnerData && partnerData?.company_name && partnerData?.company_name != '') ? partnerData?.company_name.split(' ')?.[0].toLowerCase() : partner
          const facilityEncrypt = encryptedFacilityKey(extendFacilityData?.facility?.id)

          // const pushBack = JSON.parse(localStorage.getItem('history'))
          // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
          localStorage.removeItem('paymentRecipt')
          localStorage.removeItem('ExtendData')
          navigate(`/${partner}/touchless-parking-${partnerSLug}/${facilityEncrypt}`)
          setIsEndingParking(false)

        }, 3000)
      }
      notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
    })
  }

  const handleValidateTicket = (paymentData) => {
    if (paymentData?.paid_date) {
      notify('error', 'This ticket is already validated.')
    } else {
      navigate(`/${partner}${URL?.SCAN_VALIDATE}`, { state: { redirectUrl: `/${partner}/paymentResponse/${paymentData?.ticket_number}` } })
    }
  }

  return (
    (loader || isEndingParking) ? <div className='main d-flex align-items-center justify-content-center'><Loader /></div> : <div className={faciltyData ? 'PaveConfirmation' : 'PaveConfirmation main'}>
      {!error ? <><MiniHeader isDisplayBack={true} title={'Current Parking Session'} />
        {partner ? <>
          {/* <h4 className='headerParking my-3 text-info'>Thank You</h4> */}
          <UpperHeader faciltyData={faciltyData} totalHoursLength={faciltyData?.length?.toString()} isDirection screen='extend' partnerDetails={partnerDetails} />

          <StartEndDate paymentData={faciltyData} />
          {faciltyData?.id ? <QRCodeComp paymentData={faciltyData} screen='extend' isLicensePlate isMessage partnerDetails={partnerDetails} /> : null}

          {/* {isCouponApplied == 'false' && <PromoCode  */}
          {(partner !== 'intrapark' && isPromoValidateButton(faciltyData, ['1', '3']) && !faciltyData?.event_id) &&
            (!faciltyData?.permit_request_id || faciltyData?.permit_request_id == '') && (faciltyData?.payment_method != 'APL' && faciltyData?.payment_method != 'GPAY') &&
            <PromoCode
              isTicketApply
              notify={notify}
              setPaymentData={setFaciltyData}
              screen='extend'
              ticketDetails={faciltyData}
              discountAvailed={faciltyData?.paid_type}
              setPromoCode={setPromoCode}
              promoCode={promoCode}
              setIsSubmittingForm={() => { }}
              setCustomeLoaderForRateBand={() => { }}
              isPromoCodeAppiled={isPromoCodeAppiled}
              setIsPromoCodeApplied={setIsPromoCodeApplied}
              selectedPastDate={null}
            // NOTE:- faciltyData?.paid_type === '9' means ticket is not validated except from this restrict promocode:- condition from @Vikrant
            />
          }
          {/* {(priceGreaterOrNot(faciltyData)) && <p className='text-primary my-2 fw-semibold py-1 ps-3 bg-primary bg-opacity-10' >Price Breakup</p>} */}
          <div className="container pt-3 pb-5 overflow-hidden">
            <div className={(!priceGreaterOrNot(faciltyData) && !loader) ? 'card shadow rounded-lg receiptCard no-view' : 'card shadow rounded-lg receiptCard'}>
              <PaymentBreakUpDetails
                paymentData={faciltyData}
                className="my-2 m-2 d-flex justify-content-between"
                sectionKey={((faciltyData?.payable_amount != '0.00') && faciltyData?.payable_amount) ? '' : 'paymantResponse'}
                isDisplayDetails={true}
                setIsDisplayDetails={setIsDisplayDetails}
                isExtendDetails
                breakDownTitle="Price Breakdown"
                screen="extendResponse"

              />
              <div className="card-footer">
                <AmountPaid
                  className="row justify-content-between"
                  paymentData={faciltyData}
                  paybleText='Amount Paid'
                  sectionKey={((faciltyData?.payable_amount != '0.00') && faciltyData?.payable_amount) ? '' : 'paymantResponse'}
                  // isInfo
                  hideTaxIncluded={((faciltyData?.payable_amount > 0 || faciltyData?.amount_paid > 0) && (((faciltyData?.tax_fee && faciltyData?.tax_fee != '0.00') || (faciltyData?.tax_rate && faciltyData?.tax_rate != '0.00')))) ? false : true}
                  setIsDisplayDetails={setIsDisplayDetails}
                />
              </div>
            </div>
          </div>

          <ClockTimer
            screen={'extend'}
            facilityData={faciltyData}
          />
          <Row className='m-auto w-100 justify-content-center'>
            {isWalletPermission ? <div className="container mb-3 col-12 col-sm">
              <PassWalletButtons ticketId={faciltyData?.ticket_number} />
            </div> : null}
            {(isPromoValidateButton(faciltyData, ['2', '3'], faciltyData) && (faciltyData?.payment_method != 'APL' && faciltyData?.payment_method != 'GPAY') && checkEstimateTime(faciltyData, faciltyData) && faciltyData?.facility?.facility_configuration?.is_display_validate_button == 1 && (!faciltyData?.reservation_id || faciltyData?.reservation_id === null) && (!faciltyData?.paid_date) && (!faciltyData?.event_id && !faciltyData?.pass_id && !faciltyData?.permit_request_id)) && faciltyData?.is_checkout != '1' &&
              <div className='mb-3 col-12 col-sm'>
                <button
                  type="button"
                  className='text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'
                  onClick={() => handleValidateTicket(faciltyData)}
                >
                  Validate Ticket
                </button>
              </div>}
            {(!faciltyData?.event_id && !faciltyData?.pass_id && !faciltyData?.permit_request_id) ?
              <>
                <div className={`${(isPromoValidateButton(faciltyData, ['2', '3'], faciltyData) && (!faciltyData?.reservation_id || faciltyData?.reservation_id === null) && (!faciltyData?.paid_date) && (!faciltyData?.event_id && !faciltyData?.pass_id && !faciltyData?.permit_request_id) && (faciltyData?.facility?.is_end_parking != 0 && isExtendButton(faciltyData?.facility, ['1']))) ? 'col-12 col-sm-8' : 'col-12 col-sm'}`}>
                  <ExtendEndButton
                    handleEndParking={handleConfimationModal}
                    handleExtend={handleExtend}
                    screen='extend'
                    isEndParking
                    syncWithBtns
                    facilityData={faciltyData?.facility}
                    paymentData={faciltyData}
                    isValidateTicketVisible={(isPromoValidateButton(faciltyData, ['2', '3'], faciltyData) && (!faciltyData?.reservation_id || faciltyData?.reservation_id === null) && (!faciltyData?.paid_date) && (!faciltyData?.event_id && !faciltyData?.pass_id && !faciltyData?.permit_request_id))}
                    setBtnLoader={setBtnLoader}
                    btnloader={btnloader}
                  />
                </div>
              </>
              : ''}

          </Row>
          {(faciltyData?.facility?.facility_configuration?.terms_condition_content && faciltyData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '') ? <div className="m-2 p-2 card" dangerouslySetInnerHTML={{ __html: faciltyData?.facility?.facility_configuration?.terms_condition_content ? faciltyData?.facility?.facility_configuration?.terms_condition_content : partnerDetails?.brand_setting?.terms_condition_content }} /> : null}
        </> : <NoData message={errorMessage?.invalidPartner} />} </> : <NotFound />}
      <PaymentBreakUpDetails
        paymentData={faciltyData}
        className="my-2"
        sectionKey={((faciltyData?.payable_amount != '0.00') && faciltyData?.payable_amount) ? '' : 'paymantResponse'}
        isDisplayDetails={isDisplayDetails}
        setIsDisplayDetails={setIsDisplayDetails}
        isExtendDetails
      />
      <Footer />
      <ConfirmationModal
        isConfimationModalOpen={isConfimationModalOpen}
        setIsConfimationModalOpen={setIsConfimationModalOpen}
        finalAction={handleEndParking}
      />

    </div>
  )
}

ExtendResponse.propTypes = {
  dispatch: PropTypes.func,
  isFetching: PropTypes.bool,
  loader: PropTypes.bool,
  notify: PropTypes.func,
  partnerDetails: PropTypes.object,
}

ExtendResponse.defaulProps = {
  dispatch: noop,
  loader: false,
  isFetching: false,
  notify: noop,
  partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ transientReducer, ReceiptsReducer }) {
  return {
    // loader: transientReducer?.loader,
    loader: ReceiptsReducer?.loader,

    isFetching: transientReducer?.isFetching
  }
}

export default connect(mapStateToProps)(ExtendResponse)